import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { AddProfilePicPage } from './add-profile-pic.page';

const routes: Routes = [
  {
    path: '',
    component: AddProfilePicPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [AddProfilePicPage]
})
export class AddProfilePicPageModule {}
